
  document.addEventListener("click", function (t) {
    const i = t.target.closest(".quick-add__button");
    if (!i) return;
    t.preventDefault(), t.stopImmediatePropagation();
    const n = i.dataset.handle;
    n ? fetch(`/products/${n}?view=quickview`).then(t => t.json()).then(t => {
      let i = "";
      (t.tags || []).forEach(t => {
        t.includes("style-number:") && (i = t.split(":")[1])
      }), i ? loadSiblings(i).then(() => {
        initQuickView(t, i)
      }) : initQuickView(t, "")
    }).catch(t => console.log("Fetch error:", t)) : console.log("No handle found")
  });
  let siblings = [];

  function extractTag(t, i) {
    let n = "";
    return (t || []).forEach(t => {
      t.toLowerCase().includes(i + ":") && (n = t.split(":")[1].trim())
    }), n
  }

  function getProductImages(t, i = {}) {
    let n = t.media || [];
    if (!n.length && t.images && (n = t.images.map(t => ({
      src: t,
      alt: ""
    }))), !n.length) return [];
    const e = n.filter(t => {
      const n = (t.alt || "").toLowerCase();
      return i.color && n.includes(i.color.toLowerCase()) || i.fit && n.includes(i.fit.toLowerCase())
    });
    return e.length ? e : n
  }

  function loadSiblings(t) {
    return fetch(`/search?q=style-number:${t}&type=product&view=quickview`).then(t => t.json()).then(t => {
      siblings = [], t.forEach(t => {
        const i = t.color || extractTag(t.tags || [], "color"),
          n = t.fit || extractTag(t.tags || [], "fit");
        siblings.push({
          ...t,
          color: i,
          fit: n
        })
      })
    })
  }

  function initQuickView(t, i) {
    if (!t || !t.product) return;
    window.quickViewInstance && window.quickViewInstance.$destroy();
    const n = t.product,
      e = t.tags || [],
      s = extractTag(e, "color"),
      o = extractTag(e, "fit"),
      a = n.variants[0],
      r = [...new Set(siblings.map(t => t.color))].filter(Boolean),
      c = [...new Set(siblings.map(t => t.fit))].filter(Boolean);
    window.quickViewInstance = new Vue({
      el: "#quick-view-app",
      delimiters: ["[[", "]]"],
      data: {
        styleNumber: i,
        imageKey: 0,
        currentProduct: n,
        currentVariant: a,
        currentOptions: {
          color: s || a.option1,
          fit: o,
          dm: "",
          size: ""
        },
        colorOptions: r,
        fitOptions: c,
        description: t.description || n.description,
        images: getProductImages(n, {
          color: s,
          fit: o
        }),
        quantity: 1,
        addButtonText: "Select a size",
        canAddToCart: !1
      },
      computed: {
        formattedPrice() {
          return this.currentVariant ? this.formatMoney(this.currentVariant.price) : ""
        },
        dmOptions() {
          const t = {},
            i = this.currentOptions.size;
          return this.currentProduct.variants.forEach(n => {
            const e = n.option2;
            if (!e || "na" === e.toLowerCase()) return;
            const s = !i || n.option3 === i;
            t[e] || (t[e] = {
              value: e,
              inStock: !1
            }), s && n.available && (t[e].inStock = !0)
          }), Object.values(t).sort((t, i) => parseFloat(t.value) - parseFloat(i.value))
        },
        sizeOptions() {
          const t = {},
            i = this.currentOptions.dm;
          return this.currentProduct.variants.forEach(n => {
            const e = n.option3;
            if (!e || "na" === e.toLowerCase()) return;
            const s = !i || n.option2 === i;
            t[e] || (t[e] = {
              value: e,
              inStock: !1
            }), s && n.available && (t[e].inStock = !0)
          }), Object.values(t).sort((t, i) => parseFloat(t.value) - parseFloat(i.value))
        }
      },
      mounted() {
        this.safeInitImages(), setTimeout(() => {
          this.safeInitImages()
        }, 300)
      },
      methods: {
        formatMoney: t => t ? "undefined" != typeof Shopify ? Shopify.formatMoney(t, Shopify.money_format).replace(/\.00/g, "").replace(/(\.\d{1,2})/g, "") : Math.floor(t / 100) : "",
        checkSelections() {
          const t = this.dmOptions && this.dmOptions.length > 0,
            i = this.fitOptions && this.fitOptions.length > 0,
            n = this.sizeOptions && this.sizeOptions.length > 0,
            e = !t || !!this.currentOptions.dm,
            s = !i || !!this.currentOptions.fit,
            o = !n || !!this.currentOptions.size;
          e && s && o && this.currentVariant && this.currentVariant.available ? (this.addButtonText = "Add to Cart", this.canAddToCart = !0) : (this.addButtonText = "Select a size", this.canAddToCart = !1)
        },
        updateVariant() {
          const t = this.currentOptions.dm,
            i = this.currentOptions.size,
            n = this.dmOptions && this.dmOptions.length > 0,
            e = this.currentProduct.variants.find(e => {
              const s = !i || e.option3 === i,
                o = !n || e.option2 === t;
              return s && o
            });
          this.currentVariant = e || this.currentProduct.variants[0] || null, this.checkSelections(), this.currentVariant && this.currentVariant.featured_image && (this.images = getProductImages({
            media: [this.currentVariant.featured_image]
          }, this.currentOptions), this.imageKey++, this.$nextTick(() => this.safeInitImages()))
        },
        selectOption(t, i) {
          if (this.currentOptions[t] = i, "color" === t || "fit" === t) {
            const t = this.getExactProduct(this.currentOptions.color, this.currentOptions.fit);
            t && fetch(`/products/${t.handle}.js`).then(t => t.json()).then(t => {
              this.currentProduct = t;
              const i = this.currentOptions.dm,
                n = this.currentOptions.size;
              this.currentProduct.media = (t.images || []).map(t => ({
                src: t,
                alt: ""
              })), this.images = getProductImages(this.currentProduct, this.currentOptions), this.imageKey++, this.$nextTick(() => this.safeInitImages());
              const e = t.variants.find(t => t.option2 === i && t.option3 === n);
              e ? (this.currentOptions.dm = i, this.currentOptions.size = n, this.currentVariant = e) : this.currentVariant = t.variants[0] || null, this.checkSelections()
            })
          }
          "dm" !== t && "size" !== t || this.updateVariant(), this.checkSelections()
        },
        addToCart() {
          this.currentVariant && this.currentVariant.available && fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              id: this.currentVariant.id,
              quantity: this.quantity,
              properties: {
                Fit: this.currentOptions.fit,
                "Style #": this.currentVariant.sku
              }
            })
          }).then(() => {
            document.dispatchEvent(new CustomEvent("theme:cart:refresh"))
          })
        },
        safeInitImages() {
          this.$nextTick(() => {
            const t = document.querySelector("#quick-view-app");
            if (!t) return;
            const i = t.querySelector("product-images");
            if (i) try {
              i.slider && "function" == typeof i.slider.destroy && i.slider.destroy(), "function" == typeof i.init && i.init(), window.theme && "function" == typeof window.theme.initSliders && window.theme.initSliders()
            } catch (t) {
              console.log("Slider init error", t)
            }
          })
        },
        getExactProduct: (t, i) => siblings.find(n => n.color === t && n.fit === i),
        getColorSwatch(t) {
          const i = siblings.find(i => i.color === t);
          return i && i.image ? i.image : ""
        },
        isColorAvailable: t => siblings.some(i => i.color === t && i.variants.some(t => t.available)),
        isFitAvailable(t) {
          const i = this.getExactProduct(this.currentOptions.color, t);
          return !!i && i.variants.some(t => t.available)
        }
      },
      template: '\n\n<div class="quick-view-inner">\n\n  \x3c!-- IMAGES --\x3e\n  <product-images \n  class="product-quick-add__images product__images product__images--thumbs product__images--mobile-thumbs"\n  :data-active-media="\'quickview-\' + imageKey"\n  data-fader-desktop\n>\n\n  <div \n    class="product__slides is-animated"\n    data-product-media-list\n    data-animation="drawer-images-fade"\n    data-animation-duration="500"\n    data-animation-delay="200"\n  >\n\n    <div \n      v-for="(img, index) in images"\n      :key="imageKey + \'-\' + index"\n      class="product__slide"\n      :class="index === 0 ? \'media--active\' : \'media--hidden\'"\n      :data-media-id="\'quickview-\' + index"\n      data-type="image"\n      data-slide\n    >\n\n      <div class="product__photo" tabindex="0">\n\n        <figure class="image-wrapper image-wrapper--cover lazy-image lazy-image--backfill">\n\n    <a :href="\'/products/\' + currentProduct.handle">\n       <img\n            :src="img.src || img.preview_image?.src"\n            :alt="img.alt || \'\'"\n            loading="lazy"\n          />\n\n  </a>  \n      </figure>\n\n      </div>\n\n    </div>\n   \n\n  </div>\n\n\n</product-images>\n\n \x3c!-- ✅ TITLE --\x3e\n  <div class="product__block product__head block-padding is-animated">\n    <div class="product__title__wrapper">\n      <h1 class="product__title heading-small">\n        <a :href="\'/products/\' + currentProduct.handle">\n          <span> [[ currentProduct.title.split(\'|\').pop().trim() ]]</span>\n        </a>\n      </h1>\n    </div>\n  </div>\n\n  \x3c!-- ✅ PRICE --\x3e\n  <div class="product__block block-padding is-animated">\n    <div class="product__price__wrap">\n      <div class="price product__price price--large">\n        <div class="price__container">\n          <div class="price__regular">\n            <span class="price-item price-item--regular">\n              [[ formattedPrice ]]\n            </span>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  \x3c!-- COLOR --\x3e\n  <div class="prod-info__option">\n    <div class="prod-info__option__header">\n      <span class="label">Color </span>\n      <span>/  [[ currentOptions.color ]]</span>\n    </div>\n\n    <div class="prod-info__option__colors">\n      <div v-for="c in colorOptions"\n        :class="[\'color-swatch\', currentOptions.color === c ? \'selected\' : \'\', !isColorAvailable(c) ? \'soldout\' : \'\']">\n\n        <button\n          :disabled="!isColorAvailable(c)"\n          @click="selectOption(\'color\', c)"\n          :style="{ backgroundImage: \'url(\' + getColorSwatch(c) + \')\' }">\n        </button>\n\n      </div>\n    </div>\n  </div>\n\n  \x3c!-- FIT --\x3e\n  <div class="prod-info__option" v-if="fitOptions.length">\n    <div class="prod-info__option__header"><span class="label">Fit</span></div>\n\n    <div class="prod-info__option__options">\n      <button v-for="f in fitOptions"\n        @click="selectOption(\'fit\', f)"\n        :class="[\'chip\', currentOptions.fit === f ? \'selected\' : \'\', !isFitAvailable(f) ? \'soldout\' : \'\']">\n        [[ f ]]\n      </button>\n    </div>\n  </div>\n\n  \x3c!-- DM --\x3e\n<div class="prod-info__option" v-if="dmOptions.length">\n    <div class="prod-info__option__header"><span class="label">Neck</span></div>\n\n    <div class="prod-info__option__options">\n      <button v-for="dm in dmOptions"\n        @click="selectOption(\'dm\', dm.value)"\n        :class="[\'chip\', currentOptions.dm === dm.value ? \'selected\' : \'\', !dm.inStock ? \'soldout\' : \'\']">\n        [[ dm.value ]]\n      </button>\n    </div>\n  </div>\n\n  \x3c!-- SIZE --\x3e\n  <div class="prod-info__option">\n    <div class="prod-info__option__header"><span class="label">Sleeve</span></div>\n\n    <div class="prod-info__option__options">\n      <button v-for="size in sizeOptions"\n        @click="selectOption(\'size\', size.value)"\n        :class="[\'chip\', currentOptions.size === size.value ? \'selected\' : \'\', !size.inStock ? \'soldout\' : \'\']">\n        [[ size.value ]]\n      </button>\n    </div>\n  </div>\n\n  <div class="prod-info__description" v-if="description"> <div v-html="description"></div> </div>\n\n  \x3c!-- ADD TO CART --\x3e\n  <div class="product-form__buttons">\n    <button class="btn btn--full" :disabled="!canAddToCart" @click="addToCart">\n      [[ addButtonText ]]\n    </button>\n  </div>\n\n</div>\n'
    })
  }
